import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import {Button} from 'antd'
import DateCell from '../../../elements/Table/Cells/DateCell'
import OrganisationsSelect from '../../../elements/Select/Organistaions'

function ControlledDocList(props) {
  const {onShow, list, fetching, fetch, company, onChangeCompany} = props
  const columns = [
    {
      Header: 'Code',
      accessor: 'code',
      width: 200,
      Cell: ({value, original}) => (
        <a onClick={() => onShow(original, 'edit')}>{value}</a>
      ),
    },
    {Header: 'Document Title', accessor: 'title'},
    {Header: 'Type', accessor: 'docType.code'},
    {Header: 'Effective Date', accessor: 'effectiveDate', Cell: DateCell},
    {Header: 'Activity', accessor: 'activity.code'},
    {Header: 'Process Owner', accessor: 'processOwner.fn'},
    {Header: 'Mgmt. Sponsor', accessor: 'mgmtSponsor.fn'},
  ]

  return (
    <CustomTable
      CreateButton={() => (
        <Button type={'primary'} size="small" icon={'plus'} onClick={onShow}>
          New
        </Button>
      )}
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      columns={columns}
      ExtraOptionsButtons={() => (
        <OrganisationsSelect
          value={company}
          onChange={onChangeCompany}
          placeholder={'Filter by a company'}
          size={'small'}
          style={{width: '450px', paddingRight: 20, float: 'right'}}
        />
      )}
    />
  )
}

ControlledDocList.propTypes = {}
ControlledDocList.defaultProps = {}

export default ControlledDocList
